/*
 * @Author: Liux
 * @Date: 2019-12-02 03:14:56
 * @LastEditor: Liux
 * @LastEditTime: 2020-08-13 02:12:44
 */
import {
  NgModule,
  ModuleWithProviders,
  InjectionToken,
  Provider,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  CalendarModule,
  DateAdapter,
  CalendarDateFormatter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import {
  AdDateRangeComponent,
  DateRange_Fommat_CONFIG,
} from './ad-date-range.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { AdDateRangePopupComponent } from './popup/ad-date-range-popup.component';
import { AdTextModule } from '../ad-text/ad-text.module';
import { AdCalendarDateFormatter } from '../ad-calendar-date-formatter.provider';
import {
  AdCommonModule,
  MonthPickerComponent,
  YearPickerComponent,
} from '../ad-common/ad-common.module';

@NgModule({
  declarations: [AdDateRangeComponent, AdDateRangePopupComponent],
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    AdTextModule,
    CalendarModule,
    AdCommonModule,
  ],
  providers: [],
  exports: [AdDateRangeComponent, AdDateRangePopupComponent, AdCommonModule],
  //entryComponents: [AdDateRangePopupComponent],
})
export class AdDateRangeModule {
  static forChild(providers: Provider[]): ModuleWithProviders<AdDateRangeModule> {
    return {
      ngModule: AdDateRangeModule,
      providers,
    };
  }

  static forRoot(providers: Provider[] = []): ModuleWithProviders<AdDateRangeModule> {
    return {
      ngModule: AdDateRangeModule,
      providers: [
        ...CalendarModule.forRoot(
          {
            provide: DateAdapter,
            useFactory: adapterFactory,
          },
          {
            dateFormatter: {
              provide: CalendarDateFormatter,
              useClass: AdCalendarDateFormatter,
            },
          }
        ).providers,
        ...providers,
      ],
    };
  }
}

export * from './common/ad-date-range-model';

export { AdDateRangeComponent, AdDateRangePopupComponent };

export { DateRange_Fommat_CONFIG };
